import GgVarFlavorIntensityPqChart from './GgVarFlavorIntensityPqChart';
export default GgVarFlavorIntensityPqChart;